<div class="login-wrapper" fxLayout="row wrap" fxLayoutAlign="center center">
  <mat-card fxLayout="column">
    <div
      class="mat-elevation-z4"
      fxLayoutAlign="center start"
      mat-card-lg-image
      *ngIf="logo"
      [style.minHeight.px]="logo.logo_height"
    >
      <portal-logo
        [hidden]="!logoLoaded"
        [@fadeOnLoad]="logoLoaded ? 'visible' : 'hidden'"
        [logo]="logo"
        (loaded)="logoLoaded = true"
      ></portal-logo>
    </div>
    <mat-card-content fxLayout="row wrap" fxFlex fxLayoutAlign="center start">
      <mat-icon>warning</mat-icon>
      <h1 class="mat-h1" fxFlex="100%">
        404 Page not Found! <br />
        <span>
          ☉_☉
        </span>
      </h1>
      <a type="submit" mat-button routerLink="/home">
        RETURN TO MAIN SCREEN
      </a>
    </mat-card-content>
  </mat-card>
  <div
    class="apogee"
    fxFlex="100%"
    fxLayout="row wrap"
    fxLayoutAlign="center start"
  >
    <img
      src="assets/icons/logo-black.png"
      alt="Apogee logo"
      aria-label="Apogee logo"
      width="120px"
    />
    <p fxFlex="100%">{{ apogee }}</p>
  </div>
</div>
